import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import ButtonLink from '../../components/Button/ButtonLink';
import Icon from '../Icon/Icon';

import './Footer.scss';
function Footer(props) {

	const classes = [ 'footer footer-bg--image' ];
	if (props.className) {
		classes.push(props.className);
	}

	return (
		<section className={classes.join(' ')}>
			<div className="box flx">

				<div className="cell flx-cell limit-centre">
					<Logo type="not-mine" className="footer-brand" />
					<p>Building and delivering highly stable and intelligent custom software solutions.</p>
					<p>Company websites designed to be engaging, to communicate your message and built to get the most out of your Search Engine Optimisation (SEO) and Digital Marketing investment. </p>
					<p className=" footer-heading business-details">Postal Address</p>
					<p>Suite 11, 47 Forrest Avenue, East Perth WA 6004</p>
				</div>

				<div className="cell flx-cell footer-right  limit-centre">

					<div className="footer-contact-box">
						<p className=" footer-heading business-details">Get in touch</p>
						<ButtonLink to="/contact/" className="rev" icon="comment">Message Us</ButtonLink>
						<ButtonLink to="https://www.linkedin.com/" className="rev" icon="linked-in" target="_exit">Linked In</ButtonLink>
						<ButtonLink to="/contact/" className="rev" icon="map-marker">View Map</ButtonLink>
						<ButtonLink to="/contact/" className="rev" icon="phone">1300 596 400</ButtonLink>
					</div>

					<div className="footer-links-box">
						<p className=" footer-heading business-details">Quick Links</p>
						<ul className="quick-links">
							<li><Link to="/sitemap/" label="View the sitemap"><Icon type='sitemap' />Sitemap</Link></li>
							<li><Link to="/privacy-policy/" label="View the privacy policy"><Icon type='privacy' />Privacy Policy</Link></li>
							<li><Link to="/contact/" label="Link to contact us form"><Icon type='email' />Contact</Link></li>
						</ul>
					</div>

				</div>

			</div>
			<div className="box disclaimer">
					<span><nobr>CODEBASE Pty Ltd</nobr> </span>
					<span><nobr>ACN 126 309 911 </nobr> </span>
					<span>&copy;2002-2025.</span>
					<br /><span>CODEBASE &reg; is a registered trademark of CODEBASE Pty Ltd.<br />Content is protected by copyright and may not be used or distributed without written consent.</span>
				</div>
		</section>
	);
}
export default Footer;